import React, { useState } from 'react';
import toast from 'react-hot-toast';
import './NewsLetter.css';
import { 
  FaEnvelope, 
  FaCheckCircle, 
  FaUserFriends,
  FaRocket,
  FaShieldAlt,
  FaBell
} from 'react-icons/fa';
import { MdEmail } from 'react-icons/md';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailError, setEmailError] = useState('');
  const [subscriptionType, setSubscriptionType] = useState('all');


  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setEmailError('');

    if (!email.trim()) {
      setEmailError('Email address is required');
      toast.error('Please enter your email address');
      return;
    }

    if (!validateEmail(email)) {
      setEmailError('Please enter a valid email address');
      toast.error('Invalid email format. Please check and try again.');
      return;
    }

    if (!name.trim()) {
      toast.error('Please enter your name');
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await mockApiCall({ email, name, subscriptionType });
      
      if (response.success) {
        toast.success(
          (t) => (
            <div className="success-toast">
              <div className="toast-header">
                <FaCheckCircle className="toast-icon" />
                <span>Welcome to NepliShop Family! 🎉</span>
              </div>
              <div className="toast-content">
                <p><strong>Hi {name}!</strong></p>
                <p>Your subscription to our newsletter has been confirmed.</p>
                <ul className="toast-benefits">
                  <li>✓ Check your inbox for a 15% welcome discount</li>
                  <li>✓ First exclusive offer coming in 24 hours</li>
                  <li>✓ Stay tuned for VIP updates</li>
                </ul>
                <p className="toast-note">
                  Can't find our email? Check your spam folder or 
                  <a href="#" className="resend-link"> click here to resend</a>
                </p>
              </div>
            </div>
          ),
          {
            duration: 6000,
            position: 'top-center',
            style: {
              background: '#ff4141',
              color: 'white',
              maxWidth: '500px',
              padding: '5px',
              marginLeft: '40px',
              borderRadius: '25px'
            }
          }
        );

      } else {
        throw new Error('Subscription failed');
      }
    } catch (error) {
      console.error('Subscription error:', error);
      
      toast.error(
        (t) => (
          <div className="error-toast">
            <div className="error-header">
              <span>Subscription Failed</span>
            </div>
            <div className="error-content">
              <p>We couldn't process your subscription. This could be because:</p>
              <ul>
                <li>Email already subscribed</li>
                <li>Temporary server issue</li>
                <li>Network connection problem</li>
              </ul>
              <div className="error-actions">
                <button 
                  className="retry-btn"
                  onClick={() => {
                    toast.dismiss(t.id);
                    handleSubmit(e);
                  }}
                >
                  Try Again
                </button>
                <button 
                  className="contact-btn"
                  onClick={() => {
                    toast.dismiss(t.id);
                    window.location.href = '/contact';
                  }}
                >
                  Contact Support
                </button>
              </div>
            </div>
          </div>
        ),
        {
          duration: 8000,
          position: 'top-center'
        }
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  const mockApiCall = async (data) => {
    await new Promise(resolve => setTimeout(resolve, 1500));
    const success = Math.random() > 0.1;
    
    if (success) {
      console.log('Subscription data:', data);
      return { success: true, message: 'Subscription successful' };
    } else {
      throw new Error('Failed to subscribe');
    }
  };

  return (
    <div className="newsletter-page">
      {/* Hero Section */}
    

      {/* Subscription Form Section */}
      <div className="subscription-section">
        <div className="subscription-container">
          <div className="subscription-header">
            <h2>Get Your Fashion Updates</h2>
            <p className="section-description">
              Subscribe now and receive your welcome discount instantly. No spam, just fashion goodness!
            </p>
          </div>

          <div className="subscription-content">
            {/* Subscription Form */}
            <div className="subscription-form-wrapper">
              <div className="form-card">
                <div className="form-header">
                  <h3>Subscribe Now & Get Upto 50% Off!</h3>
                  <p>Complete the form below to join our fashion community</p>
                </div>

                <form onSubmit={handleSubmit} className="subscription-form">
                  <div className="form-group">
                    <label htmlFor="name">
                      <FaUserFriends className="input-icon" />
                      Your Name
                    </label>
                    <input
                      type="text"
                      id="name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      placeholder="Enter your full name"
                      className="form-input"
                      disabled={isSubmitting}
                      required
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="email">
                      <MdEmail className="input-icon" />
                      Email Address
                    </label>
                    <input
                      type="email"
                      id="email"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        if (emailError) setEmailError('');
                      }}
                      placeholder="your.email@gmail.com"
                      className={`form-input ${emailError ? 'error' : ''}`}
                      disabled={isSubmitting}
                      required
                    />
                    {emailError && <span className="error-message">{emailError}</span>}
                  </div>

                  {/* Subscription Type Selection */}
                 

                  {/* Privacy Agreement */}
                  <div className="privacy-agreement">
                    <input
                      type="checkbox"
                      id="privacy"
                      defaultChecked
                      disabled={isSubmitting}
                      className="privacy-checkbox"
                    />
                    <label htmlFor="privacy">
                      I agree to receive personalized fashion updates, offers, and newsletters from NepliShop. 
                      I can unsubscribe at any time. View our{' '}
                      <a href="/privacy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                      </a>
                      .
                    </label>
                  </div>

                  {/* Security Badge */}
                  <div className="security-badge">
                    <FaShieldAlt className="security-icon" />
                    <span>Your email is safe with us. We never share your data.</span>
                  </div>

                  <button 
                    type="submit" 
                    className="subscribe-btn"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <>
                        <span className="spinner"></span>
                        Subscribing...
                      </>
                    ) : (
                      <>
                        <FaEnvelope className="btn-icon" />
                        Subscribe Now & Get Upto 50% Off
                      </>
                    )}
                  </button>

                  <p className="form-note">
                    By subscribing, you'll receive your welcome discount code immediately via email.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Newsletter;
